import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSubtitles } from '../features/subtitles/subtitleSlice';

const TestRedux = () => {
  const dispatch = useDispatch();
  const subtitlesState = useSelector((state) => state.subtitles);

  useEffect(() => {
    console.log('TestRedux - Current subtitles state:', subtitlesState);
  }, [subtitlesState]);

  const handleSetSubtitles = () => {
    const testSubtitles = [
      { id: 1, text: "Subtitle 1" },
      { id: 2, text: "Subtitle 2" }
    ];
    console.log('TestRedux - Dispatching setSubtitles with:', testSubtitles);
    dispatch(setSubtitles(testSubtitles));
  };

  return (
    <div>
      <h2>Redux Test</h2>
      <button onClick={handleSetSubtitles}>Set Subtitles</button>
      <pre>{JSON.stringify(subtitlesState, null, 2)}</pre>
    </div>
  );
};

export default TestRedux;
